export default __webpack_public_path__ + "static/media/icon-emailed.5e558afe.svg";